import { render, staticRenderFns } from "./BalanceUpdateSummary.vue?vue&type=template&id=03be49b8&scoped=true"
import script from "./BalanceUpdateSummary.vue?vue&type=script&lang=js"
export * from "./BalanceUpdateSummary.vue?vue&type=script&lang=js"
import style0 from "./BalanceUpdateSummary.vue?vue&type=style&index=0&id=03be49b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03be49b8",
  null
  
)

export default component.exports